const BASE = process.env.REACT_APP_API_URL || '/api';

/**
 * Wrapper de fetch que verifica que la respuesta sea JSON antes de parsear.
 * Lanza un error con mensaje legible si el servidor devuelve HTML u otro formato.
 */
async function apiFetch(path, options = {}) {
  const url = `${BASE}${path}`;
  const res = await fetch(url, options);

  const contentType = res.headers.get('content-type') || '';
  if (!contentType.includes('application/json')) {
    throw new Error(
      `El servidor devolvió una respuesta inesperada (${res.status}) en ${url}. Verifica que REACT_APP_API_URL esté configurado correctamente.`
    );
  }

  const data = await res.json();
  return { ok: res.ok, status: res.status, data };
}

export function authHeaders() {
  const token = localStorage.getItem('odm_token');
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

export default apiFetch;
